// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__1FYIb","trGroup":"styles_trGroup__j_2D6","expanded":"styles_expanded__a7UmP"};